import { DataGrid, GridCloseIcon } from "@mui/x-data-grid";
import {
  CmpTypographyField,
  CmpTextField,
} from "../../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
import { Box, Modal } from "@mui/material";
import { useState } from "react";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";

export default function BinModal({ setBinModal, sBinModal = false ,xMediaQuery,Grid_Row,sModalRowClick,Grid_Columns=[]}) {
   



  return (
    <Modal
      open={sBinModal}
      onClose={setBinModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box 
      className="model-Variance"
      // sx={{
      //   height:xMediaQuery?"43vh":"30vh",
      //   width:xMediaQuery?"95%":"40%",
      // }}
      >
        
        <GCTitleSticky title={'Suggested Bin'} onClose={setBinModal} />
         
        <div className="py-2">
          {/* <Grid
            container
            rowSpacing={{ xs: 2, sm: 0, md: 2 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            className="align-items-end mt-1"
          >
            <Grid item xs={3} sm={2} md={2} lg={3}>
              <CmpTypographyField xcomponent={"span"} xText={"Bin Code"} />
            </Grid>
            <Grid item xs={9} sm={10} md={4} lg={9}>
              <CmpTextField
                xtabIndex={"1"}
                xValue={sBinObj.BinCd}
                xVariant={"standard"}
                xType={"text"} // text/number/password
                xName={"BinCd"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={3} sm={2} md={2} lg={3}>
              <CmpTypographyField xcomponent={"span"} xText={"Bin Name"} />
            </Grid>
            <Grid item xs={9} sm={10} md={4} lg={9}>
              <CmpTextField
                xtabIndex={"1"}
                xValue={sBinObj.BinName}
                xVariant={"standard"}
                xType={"text"} // text/number/password
                xName={"BinName"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
          </Grid> */}
           <div className="py-2">
            <div style={{ height: "70vh", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                rows={Grid_Row}
                columns={Grid_Columns}
                hideFooter={Grid_Row.length < 100}
                onRowClick={sModalRowClick}
                 
              />
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
}
